import { useEffect, useRef, useState } from "react";
import { STATIC } from "@/data/content";

// IntersectionObserver + CSS-transition reveal.
// Robust even when requestAnimationFrame is throttled (background tabs / headless).
export const Reveal = ({
  children,
  as: Tag = "div",
  delay = 0,
  y = 40,
  className = "",
  ...rest
}) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(STATIC);

  useEffect(() => {
    if (STATIC) return;
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`transition-[opacity,transform] duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${
        shown ? "opacity-100 translate-y-0" : "opacity-0"
      } ${className}`}
      style={{
        transitionDelay: `${delay}ms`,
        transform: shown ? "translateY(0)" : `translateY(${y}px)`,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};
